exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.permanent-alert[data-v-24b959d3] {\r\n    display: block !important;\r\n    opacity: 1 !important;\r\n    transition: none !important;\n}\r\n", ""]);

// exports
